import { Button as ArthurButton, ButtonProps } from '@arthur/ui'
import { Stack, styled } from '@mui/material'
import { PropsWithChildren } from 'react'

/**
 * Button
 * @param props
 * @constructor
 */
const Button = (props: PropsWithChildren<ButtonProps>) => {
	return (
		<ButtonContainer>
			<ArthurButton {...props} />
		</ButtonContainer>
	)
}

const ButtonContainer = styled(Stack)({
	'& *': {
		cursor: 'pointer'
	}
})

export default Button
